"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DefaultPanel_1 = __importDefault(require("./DefaultPanel"));
const JoinGroupChatPanel_1 = __importDefault(require("./JoinGroupChatPanel"));
const NewDirectChatPanel_1 = __importDefault(require("./NewDirectChatPanel"));
const NewGroupChatPanel_1 = __importDefault(require("./NewGroupChatPanel"));
const panels_1 = require("../../domain/model/panels");
exports.default = LeftPanel;
function LeftPanel(props) {
    switch (props.type) {
        case panels_1.LeftPanelType.None:
            return null;
        case panels_1.LeftPanelType.Chats:
            return react_1.default.createElement(DefaultPanel_1.default, null);
        case panels_1.LeftPanelType.JoinGroupChat:
            return react_1.default.createElement(JoinGroupChatPanel_1.default, null);
        case panels_1.LeftPanelType.NewDirectChat:
            return react_1.default.createElement(NewDirectChatPanel_1.default, null);
        case panels_1.LeftPanelType.NewGroupChat:
            return react_1.default.createElement(NewGroupChatPanel_1.default, null);
    }
}
